<section class="rcx-table" [formGroup]="finalSettlementForm">
  <div class="row">
    <div class="col-lg-12">
      <div class="card btr">
        <div class="card-content">
          <div class="card-body">
            <div class="row">
              <div class="row g-3">
                <div class="col-md-3">
                  <label for="date" class="form-label">Final settlement Date<b class="text-secondary">*</b></label>
                  <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
                        class='bx bx-calendar'></i></span>
                    <input type="date" class="form-control ps-1" id="date" formControlName="date"
                      [readOnly]="context.persona === 'EMPLOYEE'" />
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="pendingDue" class="form-label">Pending Due</label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bx-building'></i></span>
                    <input type="text" class="form-control ps-1" id="pendingDue" placeholder="Enter the Pending Due"
                      [ngClass]="{'is-invalid': submitted && s.pendingDue?.errors}" formControlName="pendingDue"
                      autocomplete="off" [readonly]="context.persona === 'EMPLOYEE'" />
                    <div class="invalid-feedback" *ngIf="submitted && s.pendingDue?.errors">
                      <span *ngIf="s.pendingDue?.errors.required">Please enter the pendingDue.</span>
                      <span *ngIf="s.pendingDue?.errors.pattern">Only letters are allowed.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="settlementAmount" class="form-label">Settlement Amount</label>
                  <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                        class='bx bx-building'></i></span>
                    <input type="text" class="form-control ps-1" id="settlementAmount"
                      placeholder="Enter the settlement Amount"
                      [ngClass]="{'is-invalid': submitted && s.settlementAmount?.errors}"
                      formControlName="settlementAmount" autocomplete="off"
                      [readonly]="context.persona === 'EMPLOYEE'" />
                    <div class="invalid-feedback" *ngIf="submitted && s.settlementAmount?.errors">
                      <span *ngIf="s.settlementAmount?.errors.required">Please enter the feedback.</span>
                      <span *ngIf="s.settlementAmount?.errors.pattern">Only letters are allowed.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="status" class="form-label">Status<b class="text-secondary">*</b></label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-repost'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="status"
                      placeholder="Select a Resignation Status" [readonly]="context.persona === 'EMPLOYEE'"
                      [ngClass]="{'is-invalid': submitted && s.status.errors}" >
                      <ng-option *ngFor="let status of statuses" [value]="status">
                        {{status}} 
                      </ng-option>
                    </ng-select>
                  </div>
                  <div
                  *ngIf="finalSettlementForm.get('status')?.invalid && (finalSettlementForm.get('status')?.dirty || finalSettlementForm.get('status')?.touched)">
                  <small class="text-danger" *ngIf="finalSettlementForm.get('status').errors?.required">Please select the
                    status.</small>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>